import { httpClient } from '@/services/http/httpClient';

export type ConversationSource =
  | 'general_chat'
  | 'content_generation'
  | 'content_refinement'
  | 'strategy_update'
  | 'onboarding_interview'
  | 'linguistic_analysis';

export interface ChatMessage {
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
}

export interface ConversationSummary {
  id: string;
  source: ConversationSource;
  status: string;
  messageCount: number;
  /** Backend returns truncated string (first ~100 chars).
   *  Note: HIV-101 spec says { role, content } but actual BE returns plain string. */
  lastMessage?: string;
  lastActivityAt?: string;
  updatedAt?: string;
}

export interface ConversationDetail {
  id: string;
  source: ConversationSource;
  status: string;
  messages: ChatMessage[];
  metadata: {
    agent: string;
    totalTokensUsed: number;
    totalCost: number;
  };
}

interface ListConversationsResponse {
  conversations?: ConversationSummary[];
  data?: ConversationSummary[];
  total: number;
}

interface ListConversationsParams {
  page?: number;
  limit?: number;
  source?: ConversationSource;
  status?: 'active' | 'completed' | 'abandoned';
}

export const chatApi = {
  async listConversations(params?: ListConversationsParams) {
    const query = new URLSearchParams(
      Object.entries(params || {})
        .filter(([, v]) => v != null)
        .map(([k, v]) => [k, String(v)]),
    );
    return httpClient.get<ListConversationsResponse>(`/chat?${query}`);
  },

  async getConversation(conversationId: string) {
    return httpClient.get<ConversationDetail>(`/chat/${conversationId}`);
  },

  async archiveConversation(conversationId: string) {
    return httpClient.delete<{ archived: boolean }>(`/chat/${conversationId}`);
  },
};
